import AddPageDialog from "../../../components/add-page.dialog";
import { FormItem, FormType } from "../../../components/form/form-generator";
import { FileUploadCategory } from "../../../services/file-upload.service";
import {
  AlertType,
  useDashboardStore,
} from "../../dashboard/store/dashboard.store";
import { createBirthPage } from "../apis/birth-page.api";
import { BirthPageCreateEntity } from "../entities/birth-page-create.entity";
import { BirthPageCreateModel } from "../models/birth-page-create.model";

const formElements: FormItem[] = [
  {
    title: "Description",
    contentKey: "description",
    type: FormType.textArea,
  },
];

export default function AddBirthPageDialog({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const setAlert = useDashboardStore((state) => state.setAlert);
  const onSave = async (values: any) => {
    createBirthPage(BirthPageCreateModel.fromEntity(values))
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setAlert({
          message: error.response.data.message,
          type: AlertType.error,
        });
      });
  };

  return (
    <AddPageDialog
      title="Add Birth Page"
      open={open}
      setOpen={setOpen}
      page={BirthPageCreateEntity.createEmpty()}
      formElements={formElements}
      onSaveClick={onSave}
      uploadCategory={FileUploadCategory.BIRTH}
    />
  );
}
